import { __rest } from "tslib";
export const formateItem = (item, type) => {
    if (!item.content) {
        return item;
    }
    const { content } = item, rest = __rest(item, ["content"]);
    const formattedItem = Object.assign(Object.assign({}, rest), { children: undefined, label: undefined });
    if (type === 'button') {
        formattedItem.children = content;
    }
    else if (type === 'dropdown') {
        formattedItem.label = content;
    }
    return formattedItem;
};
export const getFormattedItems = ({ items, type, }) => items.map((item) => formateItem(item, type));
//# sourceMappingURL=getFormattedItems.js.map